import * as React from "react";
function SvgSwipeRight(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M27.6 1L24.8.3l1.8 2.9c-2-.4-4-.6-6-.6-3.4-.2-6.7.3-9.9 1.6-.5.2-.8.8-.6 1.3.2.4.5.6.9.6l.4-.1c2.9-1.1 6-1.6 9.1-1.4 1.8 0 3.7.2 5.5.6l-2.8 1.7 2.8.7 4-2.5L27.6 1zM20 19.9l1.4-9.1c.2-.8 0-1.6-.4-2.3s-1.1-1.1-1.9-1.3a3 3 0 00-3.5 2.3v.2l-.7 4-.9-.3c-1.1-.2-2.3.2-2.9 1.1-.4-.3-.9-.5-1.4-.5a3 3 0 00-3 1.7l-1.1-.4c-1.6-.2-3.2.9-3.4 2.5L.7 27.6c-.1.5.3 1.1.8 1.1h.1c.5 0 .9-.4 1-.9L4 18.2c.1-.6.6-.9 1.2-.9.5.1.9.6.9 1.1v.1c-.1.5.3 1 .9 1.1.5.1 1-.3 1.1-.8v-.1l.2-1.8c.1-.5.6-.9 1.1-.8.3 0 .5.2.7.4.2.2.2.5.2.7-.1.5.3 1 .9 1.1.5.1 1-.3 1.1-.8l.2-1.4c.2-.4.6-.6 1.1-.6.5.1.8.6.8 1.1l-.4 2.3c-.1.5.3 1.1.8 1.2s1.1-.3 1.2-.8l.4-2.2v-.3l1.1-6.7V10a1 1 0 011.2-.8c.3.1.5.2.6.4s.2.5.1.8l-2.2 14.8c-.1.5.3 1.1.8 1.1.5.1 1.1-.3 1.1-.8l.5-3.1c.6 1 1 2.1.8 3.2a5.1 5.1 0 01-3.3 3.8c-.5.2-.8.8-.6 1.3.2.4.5.6.9.6l.4-.1c2.3-.9 4-2.8 4.6-5.4.3-2.1-.7-4.4-2.4-5.9z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSwipeRight);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
